import React from 'react';
import { Accordion, Card, useAccordionToggle } from 'react-bootstrap';
import CollapsibleToggle from './CollapsibleToggle';
import styles from './Collapsible.module.scss';

interface ICollapsibleItem {
  eventKey: string;
  leftHeaderContent: React.ReactNode;
  children: React.ReactNode;
}

const CollapsibleItem = (props: ICollapsibleItem) => {
  const { children, eventKey, leftHeaderContent } = props;
  const handleClick = useAccordionToggle(eventKey);
  return (
    <Card>
      <Card.Header className={`d-flex ${styles.header}`} onClick={handleClick}>
        <div>{leftHeaderContent}</div>
        <div className='ml-auto align-self-center'>
          <CollapsibleToggle eventKey={eventKey} />
        </div>
      </Card.Header>
      <Accordion.Collapse eventKey={eventKey}>
        <Card.Body>{children}</Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};

export default CollapsibleItem;
